import { combineReducers } from 'redux'
import { AddCalendarEventOverlayReducer } from 'components/AddCalendarEventOverlay/reducer'
import BookingCalendarReducer from 'components/BookingCalendar/reducer'
import OrderList from 'screens/OrderList/reducer'
import PractitionerSummariesReducer from '@trybeapp/ducks.practitioner-summaries'
import { PackagesReducer as PackageTypesReducer } from '@trybeapp/ducks.packages'
import {
  BookingOrderItemsReducer,
  BookingSummariesReducer,
  OrdersReducer,
  PackageOrderItemsReducer,
  PurchaseOrderItemsReducer,
} from '@trybeapp/ducks.orders'
import { GuestsReducer } from '@trybeapp/ducks.guests'

export default combineReducers({
  OrderList,

  components: combineReducers({
    AddCalendarEventOverlayReducer,
    BookingCalendarReducer,
  }),

  resources: combineReducers({
    BookingOrderItemsReducer,
    BookingSummariesReducer,
    GuestsReducer,
    OrdersReducer,
    PackageOrderItemsReducer,
    PackageTypesReducer,
    PractitionerSummariesReducer,
    PurchaseOrderItemsReducer,
  }),
})
